export default __webpack_public_path__ + "0dcff9e295afb1b5b11eca314234e2ee.png";